export const common_questions = [
  {
    key: "date_known_well",
    text: "Date & Time of symptom onset/last known well:",
    type: "datetime",
    value_name: "ur06_date",
    value2_name: "ur06_time",
    crf_id: "c5ddc87d-8ada-4e3c-a146-a48341dbf00b",
    crf_field_id: 1,
    validation: { disableFuture: true },
    item_specific_error_validator: (valueObj) => {
      //returns true on error
      let time = valueObj.value2;
      if (parseInt(time.split(":")[0]) >= 24 || parseInt(time.split(":")[1]) >= 60) {
        return true;
      }
      return false;
    },
  },
  {
    key: "yob",
    text: "Subject Year of Birth:",
    type: "year",
    value_name: "ur06_yob",
    crf_id: "c5ddc87d-8ada-4e3c-a146-a48341dbf00b",
    crf_field_id: 2,
    item_specific_error_validator: (value) => {
      //returns true on error
      if (value.length !== 4) {
        return true;
      }
      let now = new Date();
      let now_year = now.getFullYear();
      value = parseInt(value);
      let age = now_year - value;
      if (age <= 17 || age > 105) {
        return true;
      } else return false;
    },
  },
  {
    key: "sex",
    text: "Subject Sex:",
    type: "radio",
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
    ],
    value_name: "ur06_sex",
    crf_id: "c5ddc87d-8ada-4e3c-a146-a48341dbf00b",
    crf_field_id: 3,
  },
  {
    key: "weight",
    text: "Subject Weight:",
    type: "weight",
    value_name: "ur06_weightVal",
    value2_name: "ur06_weightUnit",
    value3_name: "ur06_weightMeasure",
    crf_id: "c5ddc87d-8ada-4e3c-a146-a48341dbf00b",
    crf_field_id: 4,
    item_specific_error_validator: (valueObj) => {
      //returns true on error
      let value = valueObj.value && parseInt(valueObj.value);
      if (valueObj.value2 === "kg" && (value < 40 || value > 200)) {
        return true;
      } else if (valueObj.value2 === "lbs" && (value < 88 || value > 441)) {
        return true;
      }
      return false;
    },
  },
];

export const ais_31 = [
  {
    key: "nihss",
    text: "NIHSS immediately (<10 minutes) prior to randomization:",
    type: "int",
    value_name: "ar08_nihss",
    length: 2,
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 2,
    item_specific_error_validator: (value) => {
      value = parseInt(value);
      if (value <= 5 || value > 42) {
        return true;
      } else {
        return false;
      }
    },
  },
  {
    key: "onset_time",
    text: "Time from onset to randomization ＞ 6 hours?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 3,
  },
  {
    key: "haematoma",
    text: "Haematoma volume ≥30 mL?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 4,
  },
  {
    key: "deep_haemorrhage",
    text: "Location of supratentorial intracerebral haemorrhage is deep?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 5,
  },
  {
    key: "decompressive_surgery",
    text: "Receipt of any decompressive surgery?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 6,
  },
  {
    key: "age_over_65",
    text: "Age ≥ 65 years old?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 8,
  },
  {
    key: "intraventricular_extension",
    text: "Intraventricular extension of index ICH?",
    type: "radio",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    value_name: "iv07_doac",
    crf_id: "4b4a0544-593e-40c5-9e0f-7300a8e1c42a",
    crf_field_id: 9,
  },
];

export const question_array = {
  ais_31,
};
